import { helper as buildHelper } from '@ember/component/helper';
import { formatTokenValue } from 'mewe/utils/format-token-value';

export default buildHelper(function ([amount], { decimals = 18, fixed = 6 } = {}) {
  return formatTokenValue(amount, { decimals, fixed });
});
